<template>
  <!-- Modal -->
  <div class="modal fade" id="SingleBudgetModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">編集</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{selectedMonth + '月'}}</th>
                <th>取引先</th>
                <th>売上予算</th>
                <th>売上実績</th>
                <th>売上達成率</th>
                <th>売上前期比</th>
                <th>粗利予算</th>
                <th>粗利実績</th>
                <th>粗利達成率</th>
                <th>粗利前期比</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <template v-for="(budget, i) in tempMonthDetails">
                <tr :key="i">
                  <td><button class="btn-change minus" @click="removeDetail(i, budget)"><i></i></button></td>
                  <td class="text-nowrap min-width-200">{{budget.clients_name}}</td>
                  <td class="right">{{vat.toVatFormat(budget.sales_budget)}}</td>
                  <td class="right">{{vat.toVatFormat(budget.sales_result)}}</td>
                  <td class="right">{{budget.sales_achievement}}</td>
                  <td class="right">{{ (budget.sales_yoy && budget.sales_yoy !== "-") ? Number(budget.sales_yoy.replace("%", "").replace(",", "")).toLocaleString() + "%" : budget.sales_yoy }}</td>
                  <td class="right">{{vat.toVatFormat(budget.gross_profilt_budget)}}</td>
                  <td class="right">{{vat.toVatFormat(budget.gross_profit_result)}}</td>
                  <td class="min-width-200">
                    <div class="d-flex align-items-center">
                      <span class="table-percent-label">{{ (budget.gross_profit_achievement && budget.gross_profit_achievement !== "-") ? Number(budget.gross_profit_achievement.replace("%", "").replace(",", "")).toLocaleString() + "%" : budget.gross_profit_achievement }}</span>
                      <div class="progress w-100"><div class="progress-bar progress-bar-striped bg-info" role="progressbar" :style="'width: ' + budget.gross_profit_achievement + ''" :aria-valuenow="budget.gross_profit_achievement" aria-valuemin="0" aria-valuemax="100"></div></div>
                    </div>
                  </td>
                  <td class="right">{{ (budget.gross_profit_yoy && budget.gross_profit_yoy !== "-") ? Number(budget.gross_profit_yoy.replace("%", "").replace(",", "")).toLocaleString() + "%" : budget.gross_profit_yoy }}</td>
                </tr>
              </template>
              <tr>
                <td><button class="btn-change plus" @click="addBudget()"><i></i></button></td>
                <td>
                  <select class="form-control text-nowrap" v-model="selectedClientIndex">
                    <option v-for="(client, i) in clients" :key="i" :value="i">
                    {{client.name}}
                    </option>
                  </select>
                </td>
                <td><input type="text" min-value="0" class="form-control form-control-sm" :placeholder="Number(tempDetail.sales_budget)" v-model="tempDetail.sales_budget"></td>
                <td><input type="text" min-value="0" class="form-control form-control-sm" :placeholder="Number(tempDetail.sales_result)" v-model="tempDetail.sales_result"></td>
                <td></td>
                <td></td>
                <td><input type="text" min-value="0" class="form-control form-control-sm" :placeholder="Number(tempDetail.gross_profilt_budget)" v-model="tempDetail.gross_profilt_budget"></td>
                <td><input type="text" min-value="0" class="form-control form-control-sm" :placeholder="Number(tempDetail.gross_profit_result)" v-model="tempDetail.gross_profit_result"></td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="table-percent-label"></span>
                    <div class="progress w-100"><div class="progress-bar progress-bar-striped bg-info" role="progressbar" style="width: 0%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div>
                  </div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeUpdateModal" type="button" class="btn btn-secondary" data-dismiss="modal">閉じる</button>
          <button type="button" class="btn btn-primary" @click="updateBudgetDetail()" :disabled="hasUpdates">更新</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'SingleBudgetModal',
  components: {
    VueElementLoading
  },
  props: {
    vat: {}, // VAT
    editMonthDetails: null,
    clients: null,
    selectedMonth: Number
  },
  data () {
    return {
      tempMonthDetails: [],
      deletedDetails: [],
      tempDetail: {},
      selectedClientIndex: 0,
      isSearching: false,
      hasUpdates: true
    }
  },
  watch: {
    editMonthDetails: {
      handler (v) {
        this.tempMonthDetails = this.editMonthDetails
      },
      deep: true
    }
  },
  created () {
    this.emptyDetail()
  },
  methods: {
    filterTax (target, taxIncluded = null, vatRate = null) { // VAT INPUT @Modal
      target = target || 0
      taxIncluded = taxIncluded === null ? this.$props.vat.taxIncluded : taxIncluded
      vatRate = vatRate === null ? Number(this.$props.vat.vatRate) : Number(vatRate)
      if (!taxIncluded) {
        return target
      } else {
        let noTax = Math.round(target / ((100 + vatRate) / 100))
        return noTax
      }
    },
    emptyDetail () {
      this.tempDetail = {
        clients_id: 1,
        clients_name: '',
        sales_budget: 0,
        sales_result: 0,
        sales_achievement: '',
        sales_yoy: '',
        gross_profilt_budget: 0,
        gross_profit_result: 0,
        gross_profit_achievement: '',
        gross_profit_yoy: ''
      }
    },

    addBudget () {
      this.tempDetail.clients_id = this.clients[this.selectedClientIndex].id
      this.tempDetail.clients_name = this.clients[this.selectedClientIndex].name

      this.tempMonthDetails.push(this.tempDetail)
      this.emptyDetail()
      this.hasUpdates = false
    },

    removeDetail (index, budget) {
      if (this.tempMonthDetails.length < 2) {
        this.$toastr.warning('これ以上、削除できません。')
        return
      }

      this.deletedDetails.push(budget)
      this.tempMonthDetails.splice(index, 1)
      this.hasUpdates = false
    },

    async updateBudgetDetail () {
      let self = this
      this.isSearching = true

      let details = []
      this.tempMonthDetails.forEach(function (budget) {
        let detail = {
          clients_id: budget.clients_id,
          sales_budget: self.filterTax(budget.sales_budget), // VAT INPUT @Modal
          sales_result: self.filterTax(budget.sales_result),
          gross_profit_budget: self.filterTax(budget.gross_profilt_budget),
          gross_profit_result: self.filterTax(budget.gross_profit_result)
        }

        if (budget.id !== undefined) {
          detail.id = budget.id
        } else {
          detail.month = self.selectedMonth
        }

        details.push(detail)
      })

      this.deletedDetails.forEach(function (budget) {
        if (budget.id !== undefined) {
          details.push({
            id: budget.id
          })
        }
      })

      let params = {
        budget_id: this.$parent.budgetID,
        details: details
      }

      console.log('SingleBudget:updateBudget:params', JSON.stringify(params))

      try {
        this.$http.post(this.$api_url.budget_update_personnel, params).then(result => {
          console.log('SingleBudget:updateBudget:response', JSON.stringify(result))
          if (result.data && result.data.status === true) {
            this.$parent.getBudget()
            this.$toastr.success('予算詳細の更新を完了しました', 'Success')
            this.$refs.closeUpdateModal.click()
          } else if (result.data && result.data.message) {
            this.$toastr.error(result.data.message, 'エラー')
          } else {
            this.$toastr.error(result.data, 'エラー')
          }
          console.log('Updated Budget Detail: ', JSON.stringify(this.$parent.budgetDetails))
        })
      } catch (error) {
        console.log('error: ', JSON.stringify(error))
        this.$toastr.error('エラーが発生しました。ご確認後再試行してください。', 'エラー')
      }
      setTimeout(() => { this.isSearching = false }, 1000)
    }
  }
}
</script>
